import memoizeOne from 'memoize-one'

export const isNumber = (n?: unknown): n is number => !!n && typeof n === 'number'

export const percentChange = (original: number, newer: number): number =>
  (newer - original) / original

export const average = (arr: number[]): number =>
  arr.reduce((n, v) => n + v, 0) / arr.length

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
})

export const toUSD = memoizeOne((number: number) => formatter.format(number / 100))
